import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useT } from "../lib/LangContext";
import { ISLAND_BY_SLUG } from "../lib/constants";

const slugify = (s) =>
  (s || "").toLowerCase().replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, "-").slice(0, 60);

export const MostReadWidget = ({ island = "all" }) => {
  const { t, lang } = useT();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const params = { days: 7, limit: 5, lang };
    if (island && island !== "all") params.island = island;
    api
      .get("/articles/most-read", { params })
      .then((r) => {
        if (!cancelled) setItems(r.data || []);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      });
    return () => {
      cancelled = true;
    };
  }, [island, lang]);

  if (items.length === 0) return null;

  return (
    <div className="card-soft p-5" data-testid="most-read-widget">
      <h3 className="text-[11px] uppercase tracking-wider text-[#6B7280] mb-4 flex items-center gap-2">
        <span>🔥</span>
        <span>{t("most_read_this_week")}</span>
      </h3>
      <ol className="space-y-3">
        {items.map((a, i) => {
          const meta = ISLAND_BY_SLUG[a.island];
          const to = `/article/${a.id}${a.slug ? `-${a.slug}` : `-${slugify(a.title)}`}?lang=${lang}`;
          return (
            <li key={a.id} data-testid={`most-read-item-${i}`}>
              <Link
                to={to}
                className="flex items-start gap-3 group"
              >
                <span className="font-serif-display text-[24px] leading-none text-[#E63946] w-6 flex-shrink-0 mt-0.5">
                  {i + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="text-[13px] text-[#1A2E35] leading-snug line-clamp-2 group-hover:text-[#0AADA0] transition-colors">
                    {a.title}
                  </div>
                  <div className="text-[11px] text-[#6B7280] mt-1 flex items-center gap-1.5">
                    {meta && <span>{meta.flag}</span>}
                    {meta && <span>{meta.name}</span>}
                    <span className="text-[#6B7280]/60">·</span>
                    <span className="text-[#E63946]">🔥 {a.views}</span>
                  </div>
                </div>
              </Link>
            </li>
          );
        })}
      </ol>
    </div>
  );
};
